import React, { useEffect,useRef,useState, useCallback } from "react";
import { useSearchParams, useParams, useNavigate } from "react-router-dom";
import ErrorPage from "../ErrorPage";
import { serviceUrl, serviceSlug, SERVICE_BASE_PATH } from "../../utils/serviceUrl";
import QuestionsWizard from "./QuestionsWizard";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchHomeServices,
  fetchHomeQuestions,
  fetchHomeQuestionsOptions,
} from "../../actions/search.actions";
import { Spinner, Tabs, TabList, Tab, TabPanels, TabPanel, SimpleGrid, Box, Text, Input, Button, InputGroup, InputRightElement, IconButton } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';

function BuyStart() {
  const {t} = useTranslation();
  const [searchParams] = useSearchParams();
  // /<service-slug>/<id> (buy) or /sell/<service-slug>/<id>
  const { serviceSlug: routeServiceSlug, serviceId: routeServiceId } = useParams();
  const navigate = useNavigate();
  const searchSelect = useSelector((state) => state.search);
  const uiSelect = useSelector((state) => state.ui);

  const [isOpen, setIsOpen] = React.useState(false);
  const [currentQuestions, setCurrentQuestions] = React.useState([]);
  const [currentService, setCurrentService] = React.useState({});
  const dispatch = useDispatch();
  const [parentServices, setParentServices] = React.useState([]);
  const [searchQuery, setSearchQuery] = React.useState('');
  const [suggests, setSuggests] = React.useState([]);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const tabsRef = useRef(null);
  
const checkScroll = () => {
  if (!tabsRef.current) return;
  
  const { scrollLeft, scrollWidth, clientWidth } = tabsRef.current;
  // console.log("scrollLeft",scrollLeft, "scrollWidth",scrollWidth, "clientWidth",clientWidth);
  setShowLeftArrow(scrollLeft > 0);
  setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1);
};
const scrollTabs = (direction) => {
  if (!tabsRef.current) return;
  
  const scrollAmount = 200; // Adjust this value as needed
  const newScrollLeft = tabsRef.current.scrollLeft + (direction === 'left' ? -scrollAmount : scrollAmount);
  tabsRef.current.scrollTo({ left: newScrollLeft, behavior: 'smooth' });
  setTimeout(checkScroll, 300);

};
useEffect(() => {
  // Use setTimeout to ensure the DOM has updated
  const timer = setTimeout(() => {
    checkScroll();
  }, 100);
  return () => clearTimeout(timer);
}, [parentServices]);
// Add this to handle window resize
useEffect(() => {
  const handleResize = () => {
    checkScroll();
  };
  
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);
useEffect(() => {
  const tabs = tabsRef.current;
  if (tabs) {
    tabs.addEventListener('scroll', checkScroll);
    checkScroll(); // Initial check
    return () => tabs.removeEventListener('scroll', checkScroll);
  }
}, []);

  const groupServicesByIndustry = (services) => {
    const industryOrder = ['Residential', 'Commercial', 'New Homes'];
    const industryOrderLower = industryOrder.map(i => i.toLowerCase());
    const grouped = {};
    
    services.forEach((service) => {
      const rawIndustry = (service.industry || 'Other').trim();

      // Resolve the raw industry value into one or more target groups:
      // - "both" maps to both Residential and Commercial
      // - comma separated values are split into their respective groups
      let industries;
      if (rawIndustry.toLowerCase() === 'both') {
        industries = ['Residential', 'Commercial'];
      } else if (rawIndustry.includes(',')) {
        industries = rawIndustry
          .split(',')
          .map((i) => i.trim())
          .filter(Boolean);
      } else {
        industries = [rawIndustry];
      }

      industries.forEach((industry) => {
        // Group case-insensitively so "Residential" and "residential"
        // merge into a single group.
        const key = industry.toLowerCase();
        if (!grouped[key]) {
          grouped[key] = { label: industry, services: [] };
        }
        grouped[key].services.push(service);
      });
    });

    // Return ordered array: first the predefined order (case-insensitive), then any remaining industries
    const orderedKeys = [];
    const processedKeys = new Set();

    industryOrderLower.forEach((industryLower, idx) => {
      if (grouped[industryLower]) {
        // Use the canonical casing from industryOrder for known industries.
        grouped[industryLower].label = industryOrder[idx];
        orderedKeys.push(industryLower);
        processedKeys.add(industryLower);
      }
    });

    const remainingKeys = Object.keys(grouped).filter(
      (key) => !processedKeys.has(key)
    );

    return [...orderedKeys, ...remainingKeys].map((key) => [
      grouped[key].label,
      grouped[key].services,
    ]);
  };

  const transformServices = ()=>{
    const services = searchSelect.services.buy;
    const parentServices = [];
    //const childServices = [];
    services.forEach((service) => {
      service.childServices = services.filter(
        (child) => child.parent_id === service.id
      );
      if (service.parent_id == null) {
        parentServices.push(service);
      } 
      // if(service.childServices.length>0){
      //   childServices.push(service);
      // }
    });
    setParentServices(parentServices);
   // setChildServices(childServices);
  }

  useEffect(() => {
    if (!searchSelect.services.buy || searchSelect.services.buy.length === 0) {
      dispatch({type: 'LOADING', payload: true});
      dispatch(fetchHomeServices("buy"));
    }else{
      transformServices();
      dispatch({type: 'LOADING', payload: false});
    }
    if (!searchSelect.questions || searchSelect.questions.length === 0) {
      dispatch(fetchHomeQuestions());
    }
  }, []);

  useEffect(() => {
    if (searchSelect.services.buy && searchSelect.services.buy.length > 0) {
       transformServices();
    }
  }, [searchSelect.services.buy]);

  // Opens the questions wizard for a service. The URL is the source of truth:
  // clicks navigate, and the effect below calls this once the URL resolves.
  const selectService = useCallback((service) => {
    setIsOpen(true);
    setCurrentService(service);
    setSearchQuery("");
    setSuggests([]);
    
    let currentQuestions = searchSelect.questions.filter(
      (q) => q.service_id == service.id
    );
    if(currentQuestions.length === 0){
      currentQuestions = searchSelect.questions.filter(
        (q) => q.service_id == null
      );
    }
   // console.log("question selected", currentQuestions);
    // sort currentQuestions based on display_order
    currentQuestions.sort((a, b) => parseInt(a.display_order) - parseInt(b.display_order));
    setCurrentQuestions(currentQuestions);
  }, [searchSelect.questions]);

  const handleServiceClick = useCallback((service) => {
    if (routeServiceId === String(service.id)) {
      selectService(service);
    } else {
      navigate(serviceUrl(service, "buy"));
    }
  }, [routeServiceId, selectService, navigate]);

  const handleWizardClose = () => {
    setIsOpen(false);
    if (routeServiceId) navigate(SERVICE_BASE_PATH.buy);
  };

  // Resolve the service from the URL (or a legacy ?serviceId=<id> link) and open it
  useEffect(() => {
    const services = searchSelect.services.buy;
    if (!services || services.length === 0) return;
    const legacyServiceId = searchParams.get('serviceId');
    const serviceId = routeServiceId || legacyServiceId;
    if (!serviceId) return;

    const service = services.find(s => s.id === parseInt(serviceId));
    if (!service) {
      navigate(SERVICE_BASE_PATH.buy, { replace: true });
      return;
    }
    // legacy query-string links and stale/mistyped slugs move to the canonical URL
    if (!routeServiceId || routeServiceSlug !== serviceSlug(service)) {
      navigate(serviceUrl(service, "buy"), { replace: true });
      return;
    }
    selectService(service);
  }, [routeServiceId, routeServiceSlug, searchParams, searchSelect.services.buy, selectService, navigate]);

  useEffect(() => {
    if (currentQuestions.length > 0) {
      currentQuestions.forEach((q) => {
        dispatch(fetchHomeQuestionsOptions(q.id));
      });
    }
  }, [currentQuestions, dispatch]);

  const handleSearch = ()=>{
    const services = filterServices();
   // console.log("searchQuery",searchQuery, services);
    setSuggests(services);
  }

  const filterServices = () => {
     const services = searchSelect.services.buy;
      if (!searchQuery.trim() && searchQuery.length < 3) return [];
      
      const query = searchQuery.toLowerCase().trim();
      return services.filter(service => 
          service.service_name.toLowerCase().includes(query) && service.parent_id !== null && service.status === 'active'
      );
  };

  const ServiceIcon = ({ name }) => {
  try {
    // Assuming your icons are in the public/icons directory
    const iconPath = `/services-icons/${name.toLowerCase()}.png`;
    return (
      <Box 
        as="img" 
        src={iconPath} 
        alt={name}
        objectFit="contain"
        maxWidth={"70px"}
        maxHeight={"30px"}
        mb={2}
      />
    );
  } catch (e) {
    return null;
  }
};

  if (routeServiceId && !/^\d+$/.test(routeServiceId)) {
    return <ErrorPage />;
  }

  return (
    <div className="container my-5 min-h-svh">
      <h2 className="w-full mx-auto text-3xl font-bold text-left py-5 leading-normal"><span dangerouslySetInnerHTML={{__html: t("service.buy.home.title")}}></span></h2>
        <div className={`pb-5 relative w-full mx-auto`}>
          <InputGroup size='md'>
            <Input
              pr='4.5rem'
              type={'text'}
              placeholder='Search for Service'
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyUp={(e) => handleSearch(e)}
            />
            <InputRightElement width='4.5rem'>
              <Button onClick={handleSearch}>
                Search
              </Button>
            </InputRightElement>
          </InputGroup>
          {suggests.length > 0 && (
            <Box
              position="absolute"
              width="100%"
              maxH="500px"
              overflowY="auto"
              bg="white"
              boxShadow="md"
              borderRadius="md"
              mt={0}
              zIndex="dropdown"
              border="1px"
              borderColor="gray.200"
            >
              {suggests.map((suggestion) => (
                <Box
                  key={'sgg-'+suggestion.id}
                  onClick={() => handleServiceClick(suggestion)}
                  px={4}
                  py={3}
                  _hover={{ bg: 'gray.50' }}
                  cursor="pointer"
                  borderBottom="1px"
                  borderColor="gray.100"
                  _last={{ borderBottom: 'none' }}
                >
                  <Text>{suggestion.service_name+"("+suggestion.industry+")"}</Text>
                </Box>
              ))}
            </Box>
          )}
        </div>
        <h2 className="w-full mx-auto text-xl font-bold text-left pb-20 text-gray-400">{t("service.buy.home.subtitle")}</h2>
      {uiSelect.isLoading ? (
        <div className="text-center"><Spinner size="xl" /></div>
      ) : (
        <Tabs variant="enclosed" colorScheme="blue" isLazy>
          <Box position="relative" width="100%">
            {showLeftArrow && (
              <IconButton
                icon={<ChevronLeftIcon />}
                onClick={() => scrollTabs('left')}
                position="absolute"
                left={0}
                top="50%"
                transform="translateY(-50%)"
                zIndex={1}
                bg="white"
                boxShadow="md"
                size="sm"
                aria-label="Scroll left"
              />
            )}
            <TabList 
              ref={tabsRef}
              overflowX="auto"
              overflowY="hidden"
              pt={2}
              pb={0}
              sx={{
                scrollbarWidth: 'none',
                '&::-webkit-scrollbar': {
                  display: 'none',
                },
                msOverflowStyle: 'none',
              }}
            >
              {parentServices.map((service) => (
                <Tab key={`tab-${service.id}`} whiteSpace="nowrap" px={6}>
                  {service.service_name}
                </Tab>
              ))}
            </TabList>
            
            {showRightArrow && (
              <IconButton
                icon={<ChevronRightIcon />}
                onClick={() => scrollTabs('right')}
                position="absolute"
                right={0}
                top="50%"
                transform="translateY(-50%)"
                zIndex={1}
                bg="white"
                boxShadow="md"
                size="sm"
                aria-label="Scroll right"
              />
            )}
          </Box>
          
          <TabPanels mt={0}>
            {parentServices.map((parentService) => {
              const activeChildServices = parentService.childServices?.filter(
                (childService) => childService.status === 'active'
              ) || [];
              const groupedByIndustry = groupServicesByIndustry(activeChildServices);
              
              return (
                <TabPanel key={`panel-${parentService.id}`} p={5} border="1px" borderColor="gray.200">
                  {groupedByIndustry.map(([industry, services]) => (
                    <Box key={`industry-${industry}`} mb={10}>
                      <Text fontSize="lg" fontWeight="bold" mb={4} pl={2} color="gray.700">
                        {industry}
                      </Text>
                      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4} mb={6}>
                        {services.map((childService) => (
                          <Box
                            key={`service-${childService.id}`}
                            borderWidth="1px"
                            borderRadius="lg"
                            p={5}
                            cursor="pointer"
                            bg="gray.50"
                            _hover={{ bg: 'gray.100' }}
                            onClick={() => handleServiceClick(childService)}
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            textAlign="center"
                          >
                            <ServiceIcon name={childService.field_value || childService.service_name} />
                            <Text mt={2} fontWeight={"medium"}>
                              {childService.service_name}
                            </Text>
                          </Box>
                        ))}
                      </SimpleGrid>
                    </Box>
                  ))}
                </TabPanel>
              );
            })}
          </TabPanels>
        </Tabs>
      )}
      
      <QuestionsWizard
        isOpen={isOpen}
        onClose={handleWizardClose}
        questions={currentQuestions}
        service={currentService}
        side="buy"
      />
    </div>
  );
}

export default BuyStart;
